module.exports = __webpack_public_path__ + "img/upload_default.a9d05011.png";